module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("8s8k4"))).then(() => parcelRequire('7ZdN7'));